<style scoped>

</style>
<template>
  <div>
    <Tabs
      type="card"
      @on-click="tabChange"
    >
      <TabPane
        name="asset_rule_monthly_payee_company"
        label="月结供应商"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_rule_monthly_payee_company',new_asset_rule_monthly_payee_company)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_rule_monthly_payee_company_columns"
            :data="asset_rule_monthly_payee_companys"
          />
          <Backdrop v-show="is_asset_rule_monthly_payee_company_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_rule_no_depreciate_device_type"
        label="非折旧设备类型设置"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_rule_no_depreciate_device_type',new_asset_rule_no_depreciate_device_type)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_rule_no_depreciate_device_type_columns"
            :data="asset_rule_no_depreciate_device_types"
          />
          <Backdrop v-show="is_asset_rule_no_depreciate_device_type_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_rule_no_deduct_company"
        label="不抵扣公司设置"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_rule_no_deduct_company',new_asset_rule_deduct_company)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_rule_no_deduct_company_columns"
            :data="asset_rule_no_deduct_companys"
          />
          <Backdrop v-show="is_asset_rule_no_deduct_company_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_rule_depreciate_price"
        label="需折旧单价设置"
      >
        <div class="line">
          <Table
            :columns="asset_rule_depreciate_price_columns"
            :data="asset_rule_depreciate_prices"
          />
          <Backdrop v-show="is_asset_rule_depreciate_price_loading" />
        </div>
      </TabPane>
    </Tabs>

    <div
      v-show="asset_rule_no_depreciate_device_type_page_info.total && mode === 'asset_rule_no_depreciate_device_type_page_info'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_rule_no_depreciate_device_type_page_info.current"
        :total="asset_rule_no_depreciate_device_type_page_info.total"
        :page-size="asset_rule_no_depreciate_device_type_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_rule_no_depreciate_device_type_page_info', new_page)}"
      />
    </div>
    <div
      v-show="asset_rule_no_deduct_company_page_info.total && mode === 'asset_rule_no_deduct_company'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_rule_no_deduct_company_page_info.current"
        :total="asset_rule_no_deduct_company_page_info.total"
        :page-size="asset_rule_no_deduct_company_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_rule_no_deduct_company', new_page)}"
      />
    </div>
    <div
      v-show="asset_rule_depreciate_price_page_info.total && mode === 'asset_rule_no_depreciate_price'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_rule_depreciate_price_page_info.current"
        :total="asset_rule_depreciate_price_page_info.total"
        :page-size="asset_rule_depreciate_price_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_rule_no_depreciate_price', new_page)}"
      />
    </div>

    <Modal
      v-model="edit_asset_rule_monthly_payee_company_config.modal"
      width="40"
      title="添加"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_rule_monthly_payee_company_config.loading"
      @on-ok="editOK('asset_rule_monthly_payee_company')"
    >
      <div class="line">
        <span>选择供应商:</span>
        <PayeeCompanySelector
          ref="payeeCompanySelector"
          type=""
          :hide-search-bar="true"
          @on-change="setPayeeCompany"
        >
          <i-input
            v-model="selected_payee_company_name"
            placeholder="公司名称"
            @on-change="searchPayeeCompany"
            @on-focus="searchPayeeCompany"
          />
        </PayeeCompanySelector>
      </div>
    </Modal>

    <Modal
      v-model="edit_asset_rule_no_depreciate_device_type_config.modal"
      width="400"
      title="添加"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_rule_no_depreciate_device_type_config.loading"
      @on-ok="editOK('asset_rule_no_depreciate_device_type')"
    >
      <div class="line">
        <span>选择设备:</span>
        <Select v-model="edit_asset_rule_no_depreciate_device_type.asset_device_type_id">
          <Option
            v-for="item in asset_device_types"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </Option>
        </Select>
      </div>
    </Modal>
    <Modal
      v-model="edit_asset_rule_no_deduct_company_config.modal"
      width="400"
      title="添加"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_rule_no_deduct_company.loading"
      @on-ok="editOK('asset_rule_no_deduct_company')"
    >
      <div class="line">
        <span>选择公司:</span>
        <Select v-model.trim="edit_asset_rule_no_deduct_company.company_id">
          <Option
            v-for="item in companies"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </Option>
        </Select>
      </div>
    </Modal>
    <Modal
      v-model="edit_asset_rule_depreciate_price_config.modal"
      width="400"
      title="编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_rule_depreciate_price_config.loading"
      @on-ok="editOK('asset_rule_depreciate_price')"
    >
      <div class="line">
        <span>编辑单价:</span>
        <i-input v-model.trim="edit_asset_rule_depreciate_price.price" />
      </div>
    </Modal>
  </div>
</template>
<script route="/exec/asset_rule">
  import Util from '../../libs/util';
  import PayeeCompanySelector from '../components/payee_company/selector'
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: '/exec/asset_rule',
    components: {
      PayeeCompanySelector
    },
    /* router_info_end */
    data() {
      return {
        mode: 'asset_rule_no_depreciate_device_type',
        asset_device_types: [],
        asset_rule_monthly_payee_company_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_rule_no_depreciate_device_type_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_rule_no_depreciate_device_type_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_rule_no_deduct_company_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_rule_depriciate_price_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_rule_monthly_payee_company_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_rule_no_depreciate_device_type_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_rule_no_deduct_company_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_rule_depreciate_price_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_rule_monthly_payee_company_columns: [
          {
            title: '名称',
            render: (h, params) => {
              return h('div', params.row.payee_company.name)
            }
          }, {
            title: '描述',
            render: (h, params) => {
              return h('div', params.row.payee_company.desc)
            }
          }, {
            title: '操作',
            render: (h, params) => {
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteMonthlyPayeeCompany(params.row, params.index);
                  }
                }
              }, '删除')
            }
          }
        ],
        asset_rule_no_depreciate_device_type_columns: [
          {
            title: '名称',
            render: (h, params) => {
              return h('div', params.row.asset_device_type.name)
            }
          },
          {
            title: '备注',
            render: (h, params) => {
              return h('div', params.row.asset_device_type.desc)
            }
          }, {
            title: '操作',
            render: (h, params) => {
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteNoDepreciateAssetDeviceType(params.row, params.index);
                  }
                }
              }, '删除')
            }
          }
        ],
        asset_rule_no_deduct_company_columns: [
          {
            title: '名称',
            render: (h, params) => {
              return h('div', params.row.company.name)
            }
          },
          {
            title: '描述',
            render: (h, params) => {
              return h('div', params.row.company.desc)
            }
          }, {
            title: '操作',
            render: (h, params) => {
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteNoDeductCompany(params.row, params.index);
                  }
                }
              }, '删除')
            }
          }
        ],
        asset_rule_depreciate_price_columns: [
          {
            title: '类型',
            render: (h, params) => {
              if (params.row.tax_type === 0) {
                return h('div', '不含税单价')
              } else {
                return h('div', '含税单价')
              }
            }
          },
          {
            title: '单价',
            key: 'price'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editItem('asset_rule_depreciate_price', params.row)
                  }
                }
              }, '编辑');
            }
          }
        ],
        asset_stock_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '类型',
            key: 'type',
            render: (h, params) => {
              return h('div', params.row.asset_stock_type === 0 ? '废弃仓库' : '普通仓库')
            }
          },
          {
            title: '备注',
            key: 'desc'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editItem('asset_stock', params.row)
                  }
                }
              }, '编辑');
            }
          }
        ],
        new_asset_rule_monthly_payee_company: {
          id: 0,
          payee_company_id: 0
        },
        new_asset_rule_no_depreciate_device_type: {
          id: 0,
          asset_device_type_id: 0
        },
        new_asset_rule_deduct_company: {
          id: 0,
          company_id: 0
        },
        new_asset_rule_depreciate_price: {
          id: 0,
          price: 0
        },
        new_asset_location: {
          id: 0,
          name: ''
        },
        new_asset_stock: {
          id: 0,
          name: '',
          desc: ''
        },
        selected_payee_company_name: '',
        asset_rule_monthly_payee_companys: [],
        asset_rule_no_depreciate_device_types: [],
        asset_rule_no_deduct_companys: [],
        asset_rule_depreciate_prices: [],
        edit_asset_rule_monthly_payee_company: {},
        edit_asset_rule_no_depreciate_device_type: {},
        edit_asset_rule_no_deduct_company: {},
        edit_asset_rule_depreciate_price: {},
        edit_asset_rule_monthly_payee_company_config: {
          modal: false,
          loading: true
        },
        edit_asset_rule_no_depreciate_device_type_config: {
          modal: false,
          loading: true
        },
        edit_asset_rule_no_deduct_company_config: {
          modal: false,
          loading: true
        },
        edit_asset_rule_depreciate_price_config: {
          modal: false,
          loading: true
        },
        is_asset_rule_monthly_payee_company_loading: false,
        is_asset_rule_no_depreciate_device_type_loading: false,
        is_asset_rule_no_deduct_company_loading: false,
        is_asset_rule_depreciate_price_loading: false,
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
      }),
    },
    created() {
      this.initAssetBaseData();
      this.queryItem('asset_rule_monthly_payee_company');
      this.queryItem('asset_rule_no_depreciate_device_type');
      this.queryItem('asset_rule_no_deduct_company');
      this.queryItem('asset_rule_depreciate_price');
      // Util.ajax.get(Util.api.query_all_asset_device_type, {
      //           params: {}
      //       }).then((response)=>{
      //           return response.data;
      //       }).then((res)=>{
      //           if(res.code === 1){
      //               let data = res.data;
      //               this.asset_device_types = data;
      //               // this.asset_device_types.forEach((item)=>{
      //               //     this.asset_device_types_hash[item.id] = item;
      //               // });
      //           }else{
      //               this.$Modal.error({title: '错误',content: res.msg});
      //           }
      //       }).catch((e)=>{
      //           this.$Modal.error({
      //               title: '错误',
      //               content: e.message
      //           });
      //       });
    },
    mounted() {
      //
    },
    methods: {
      initAssetBaseData() {
        Util.ajax.get(Util.api.asset_base_data, {
          params: {}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            // this.asset_brands = data.asset_brands;
            // this.asset_brands.forEach((item)=>{
            //     this.asset_brands_hash[item.id] = item;
            // });
            this.asset_device_types = data.asset_device_types;
            // this.asset_device_types.forEach((item)=>{
            //     this.asset_device_types_hash[item.id] = item;
            // });
            // this.asset_types = data.asset_types;
            // this.asset_types.forEach((item)=>{
            //     this.asset_types_hash[item.id] = item;
            // });
            // this.asset_names = data.asset_names;
            // this.asset_names.forEach((item)=>{
            //     this.asset_names_hash[item.id] = item;
            // });
            // this.asset_locations = data.asset_locations;
            // this.asset_locations.forEach((item)=>{
            //     this.asset_locations_hash[item.id] = item;
            // });
            // this.asset_stocks = data.asset_stocks.filter(asset_stock => asset_stock.asset_stock_type !== 0);
            // this.asset_no_use_stock = data.asset_stocks.filter(asset_stock => asset_stock.asset_stock_type === 0)[0]
            // this.asset_stocks.forEach((item)=>{
            //     this.asset_stocks_hash[item.id] = item;
            // });
            // this.purchase_channels = data.purchase_channels;
            // this.purchase_channels.forEach((item)=>{
            //     this.purchase_channels_hash[item.id] = item;
            // });
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({
            title: '错误',
            content: e.message
          });
        });
      },
      setPayeeCompany(company) {
        this.selected_payee_company_name = company.name;
        this.edit_asset_rule_monthly_payee_company.payee_company_id = company.id;
        document.body.click();
      },
      searchPayeeCompany() {
        this.$refs.payeeCompanySelector.search(this.selected_payee_company_name);
      },
      tabChange(name) {
        this.mode = name;
        console.log(name);
      },
      editItem(type, item) {
        this[`edit_${type}`] = Util.clone(item);
        this[`edit_${type}_config`].modal = true;
      },
      queryItem(type) {
        const loading_key = `is_${type}_loading`;
        if (!this[loading_key]) {
          this[loading_key] = true;
          Util.ajax.get(Util.api[`query_${type}`], {
            params: this[`${type}_params`]
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this[loading_key] = false;
            if (res.code === 1) {
              const data = res.data;
              this[`${type}s`] = [];
              data.items.forEach((item) => {
                this[`${type}s`].push(item);
              });
              this[`${type}_page_info`].current = data.cur_page;
              this[`${type}_page_info`].page_size = data.per_page;
              this[`${type}_page_info`].total = data.total_count;
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this[loading_key] = false;
            this.$Modal.error({
              title: '错误',
              content: e.message
            });
          });
        }
      },
      pageChange(type, new_page) {
        this[`${type}_params`].page = new_page;
        this.queryItem(type);
      },
      deleteMonthlyPayeeCompany(row, index) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确认要废弃吗？',
          onOk: () => {
            Util.ajax.post(Util.api.delete_asset_rule_monthly_payee_company, {
              id: row.id
            }).then((data) => {
              console.log(data);
              if (data.data.code === 1) {
                this.asset_rule_monthly_payee_companys.splice(index, 1);
                this.$Message.success('删除成功!');
              }
            }).catch((e) => {
              this.$Message.error('删除失败, 请重试!');
              console.log(e);
            });
          }
        })
      },
      deleteNoDepreciateAssetDeviceType(row, index) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确认要废弃吗？',
          onOk: () => {
            Util.ajax.post(Util.api.delete_asset_rule_no_depreciate_device_type, {
              id: row.id
            }).then((data) => {
              console.log(data);
              if (data.data.code === 1) {
                this.asset_rule_no_depreciate_device_types.splice(index, 1);
                this.$Message.success('删除成功!');
              }
            }).catch((e) => {
              this.$Message.error('删除失败, 请重试!');
              console.log(e);
            });
          }
        })
      },
      deleteNoDeductCompany(row, index) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确认要废弃吗？',
          onOk: () => {
            Util.ajax.post(Util.api.delete_asset_rule_no_deduct_company, {
              id: row.id
            }).then((data) => {
              console.log(data);
              if (data.data.code === 1) {
                this.asset_rule_no_deduct_companys.splice(index, 1);
                this.$Message.success('删除成功!');
              }
            }).catch((e) => {
              this.$Message.error('删除失败, 请重试!');
              console.log(e);
            });
          }
        })
      },
      editOK(type) {
        const config_key = `edit_${type}_config`;
        Util.ajax.post(Util.api[`update_${type}`], this[`edit_${type}`]).then((response) => {
          return response.data;
        }).then((data) => {
          this[config_key].loading = false;
          setTimeout(() => {
            this[config_key].loading = true;
          }, 500);
          if (data.code === 1) {
            this[config_key].modal = false;
            Util.insertOrUpdateArrayItem(this[`${type}s`], data.data, true);
          } else {
            this.$Modal.error({
              title: '错误',
              content: data.msg
            });
          }
        }).catch((e) => {
          this[config_key].loading = false;
          setTimeout(() => {
            this[config_key].loading = true;
          }, 500);
          console.log(e);
        });
      }
    }
  }
</script>
